export default __webpack_public_path__ + "b95db374d62e104f33cbefdedac750d9.png";